export const NOTIFICATION_PAGE = 'Notifications'
export const STOCK_COUNT_PAGE = 'StockCount'
